import API_URL from "./api.js";

const handleRandomFavorites = async (getToken, location, setLoading, addNotification) => {
    const notifyNoFavorites = () => {
        if (typeof addNotification === "function") {
            addNotification("Favorites collection is empty. No items to display.", "warning");
        }
    };

    setLoading(true);
    const idToken = await getToken();
    fetch(API_URL + "/favorite/getlatest?firebase_auth_token=" + idToken)
        .then(response => response.json())
        .then(data => {
            if (data.code === 200) {
                location.route("/song?s=" + data.data.youtube_url + "&p=favorite");
            } else {
                notifyNoFavorites();
                location.route("/account");
            }
        })
        .catch(() => {
            notifyNoFavorites();
            location.route("/account");
        })
        .finally(() => {
            setLoading(false);
        });
}

const getRandomSongUrl = () => {
    return fetch(API_URL + "/song/random")
        .then(response => response.json())
        .then(data => {
            if (data.code === 200) {
                return "/song?s=" + data.data.youtube_url + "&p=" + data.data.category_id;
            }
            return null;
        })
        .catch(() => null);
}

const reportSong = (song) => {
    const reason = prompt('Please enter a reason for reporting this song:');
    if (!reason || reason.length < 3) {
        alert('Please enter a valid reason.');
        return;
    }

    const formData = new FormData();
    formData.append('message', 'Song reported. ID: ' + song + '. Reason: ' + reason);
    formData.append('topic', 'song-report');

    fetch(API_URL + '/contact/request', {
        method: 'POST',
        body: formData
    })
        .then(response => response.json())
        .then(data => {
            if (data.code === 200) {
                alert('Song reported successfully!');
            }
        });
}

export {handleRandomFavorites, getRandomSongUrl, reportSong};
